import Vue from 'vue'

export default {
  /*
   * ADD
   */
  ADD_PROJECTS: (state, projects) => {
    Vue.set(state, 'projects', projects)
    state.loadingProjects = false;
  },

  /*
   * REMOVE
   */
  REMOVE_PROJECTS: (state) => {
    state.projects = []
  },

  /*
   * TOGGLE
   */
  LOADING_PROJECTS: (state, val) => {
    state.loadingProjects = val
  },
}
